module.exports = __webpack_public_path__ + "img/qingdao.c9171d56.jpg";